import { useSelector } from 'react-redux'

import LoadingScreen from './LoadingScreen'
import AuthenticatedRoutes from './AuthenticatedRoutes'
import UnauthenticatedRoutes from './UnauthenticatedRoutes'
import {
  userDidValidate,
  selectCurrentUser
} from '../redux/features/user/userSlice'

export default function AppRoutes() {
  const didValidate = useSelector(userDidValidate)
  const currentUser = useSelector(selectCurrentUser)

  if (!didValidate) {
    return <LoadingScreen />
  }

  return currentUser
    ? <AuthenticatedRoutes />
    : <UnauthenticatedRoutes />
}
